import { LOGOUT_REQUEST } from '@sit/client-shared';
import moment from 'moment';
import { handleActions } from 'redux-actions';
import { SimpleAction } from '../../types/redux/actions';
import { ProjectsStore } from '../../types/redux/stores/projects.types';
import * as actionDefinitions from './actionDefinitions';

const initialState: ProjectsStore = {
  data: [],
  perClientId: {},
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getProjectsRequest = (state: ProjectsStore): ProjectsStore => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getProjectsRequestFailure = (state: ProjectsStore, action: SimpleAction): ProjectsStore => {
  return {
    ...state,
    data: [],
    error: action.error,
    loading: false,
  };
};
const getProjectsRequestSuccess = (state: ProjectsStore, action: SimpleAction): ProjectsStore => {
  const responseData = action.payload.res;
  return {
    ...state,
    data: responseData,
    error: null,
    initialLoad: true,
    loading: false,
  };
};

const getProjectsOfClientRequest = (state: ProjectsStore, action: SimpleAction): ProjectsStore => {
  const clientId = action.payload.clientId;
  if (!clientId) return state;
  return {
    ...state,
    perClientId: {
      ...state.perClientId,
      [clientId]: {
        ...state.perClientId[clientId],
        loading: true,
      },
    },
  };
};
const getProjectsOfClientStopLoading = (state: ProjectsStore, action: SimpleAction): ProjectsStore => {
  const clientId = action.payload.clientId;
  if (!clientId) return state;
  return {
    ...state,
    perClientId: {
      ...state.perClientId,
      [clientId]: {
        ...state.perClientId[clientId],
        loading: false,
      },
    },
  };
};
const getProjectsOfClientRequestFailure = (state: ProjectsStore, action: SimpleAction): ProjectsStore => {
  const clientId = action.payload?.error?.clientId;
  if (!clientId) return state;
  return {
    ...state,
    perClientId: {
      ...state.perClientId,
      [clientId]: {
        ...state.perClientId[clientId],
        loading: false,
        lastSync: null,
      },
    },
  };
};
const getProjectsOfClientRequestSuccess = (state: ProjectsStore, action: SimpleAction): ProjectsStore => {
  const responseData = action.payload.res;
  const clientId = action.payload?.payloadData?.clientId || 'all';
  return {
    ...state,
    perClientId: {
      ...state.perClientId,
      [clientId]: {
        loading: false,
        lastSync: moment().toString(),
        data: responseData,
      },
    },
    initialLoad: true,
  };
};

const logoutRequest = () => initialState;

export default handleActions<ProjectsStore, SimpleAction>(
  {
    [actionDefinitions.GET_PROJECTS_REQUEST]: getProjectsRequest,
    [actionDefinitions.GET_PROJECTS_REQUEST_FAILURE]: getProjectsRequestFailure,
    [actionDefinitions.GET_PROJECTS_REQUEST_SUCCESS]: getProjectsRequestSuccess,
    [actionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST]: getProjectsOfClientRequest,
    [actionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST_FAILURE]: getProjectsOfClientRequestFailure,
    [actionDefinitions.GET_PROJECTS_OF_CLIENT_REQUEST_SUCCESS]: getProjectsOfClientRequestSuccess,
    [actionDefinitions.GET_PROJECTS_OF_CLIENT_STOP_LOADING]: getProjectsOfClientStopLoading,
    [LOGOUT_REQUEST]: logoutRequest,
  },
  initialState,
);
